import { ConstructorArgs } from '../types/models'
import { ReviewBase } from './ReviewBase'

type GoogleReviewConstructorArgs = ConstructorArgs<() => GoogleReview>

export class GoogleReview extends ReviewBase {
    readonly recordType = 'googlereview'

    reviewId?: string
    private _reviewerName?: string
    reviewerImage?: string

    constructor(data?: Partial<GoogleReviewConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.reviewId = data.review_id ?? undefined
        this._reviewerName = data.reviewer_name ?? undefined
        this.reviewerImage = data.reviewer_image ?? undefined
    }

    clone(overrides?: Partial<GoogleReviewConstructorArgs>): GoogleReview {
        return new GoogleReview({ ...this.serializeForClone(), ...overrides })
    }

    get reviewerName(): string {
        return this._reviewerName ?? ''
    }

    get responderName(): string {
        return 'Response from the owner'
    }
}
